// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%22292.4%22%20height%3D%22292.4%22%3E%3Cpath%20fill%3D%22%23333%22%20d%3D%22M287%2069.4a17.6%2017.6%200%200%200-13-5.4H18.4c-5%200-9.3%201.8-12.9%205.4A17.6%2017.6%200%200%200%200%2082.2c0%205%201.8%209.3%205.4%2012.9l128%20127.9c3.6%203.6%207.8%205.4%2012.8%205.4s9.2-1.8%2012.8-5.4L287%2095c3.5-3.5%205.4-7.8%205.4-12.8%200-5-1.9-9.2-5.4-12.8z%22%2F%3E%3C%2Fsvg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Add unique namespace to all selectors */
.congress-bill-split {
  width: 100%;
  max-width: 1220px;
  min-height: 600px;
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  padding: 24px 18px;
  box-sizing: border-box;
  margin: 0 auto;
}

.congress-bill-split .chart-description {
  margin-bottom: 16px;
  width: 100%;
}

.congress-bill-split .chart-description .text {
  color: #666;
  line-height: 1.6;
  font-size: 16px;
  width: 100%;
}

.congress-bill-split .chart-controls {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 20px;
  align-items: center;
  width: 100%;
  max-width: 800px;
  margin: 0 auto;
  padding: 16px;
  background: #f9f9f9;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.congress-bill-split .controls-row {
  display: flex;
  justify-content: space-between;
  width: 100%;
  gap: 20px;
}

.congress-bill-split .baseline-selector,
.congress-bill-split .bill-status-selector,
.congress-bill-split .volume-selector {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.congress-bill-split .baseline-selector label,
.congress-bill-split .bill-status-selector label,
.congress-bill-split .volume-selector label {
  text-align: center;
  display: block;
  margin-bottom: 8px;
  color: #333;
  font-size: 15px;
  font-weight: 600;
}

.congress-bill-split .baseline-select,
.congress-bill-split .bill-status-select {
  width: 100%;
  padding: 8px 12px;
  border-radius: 6px;
  border: 1px solid #e0e0e0;
  font-size: 14px;
  background: white;
  color: #333;
  cursor: pointer;
  transition: all 0.2s ease;
  appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 12px center;
  background-size: 8px;
}

.congress-bill-split .baseline-select:hover,
.congress-bill-split .bill-status-select:hover {
  border-color: #0072ed;
}

.congress-bill-split .baseline-select:focus,
.congress-bill-split .bill-status-select:focus {
  border-color: #0072ed;
  outline: none;
  box-shadow: 0 0 0 3px rgba(0, 114, 237, 0.1);
}

.congress-bill-split .volume-slider,
.congress-bill-split .baseline-slider {
  width: 100%;
  height: 6px;
  background: #edf2f7;
  border-radius: 8px;
  cursor: pointer;
  appearance: none;
  margin: 10px 0;
  transition: all 0.2s ease;
}

.congress-bill-split .volume-slider::-webkit-slider-thumb,
.congress-bill-split .baseline-slider::-webkit-slider-thumb {
  appearance: none;
  width: 20px;
  height: 20px;
  background: #0072ed;
  border: 3px solid #ffffff;
  border-radius: 50%;
  cursor: pointer;
  margin-top: -7px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}

.congress-bill-split .volume-slider:hover::-webkit-slider-thumb,
.congress-bill-split .baseline-slider:hover::-webkit-slider-thumb {
  transform: scale(1.1);
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.15);
}

.congress-bill-split .volume-slider:active::-webkit-slider-thumb,
.congress-bill-split .baseline-slider:active::-webkit-slider-thumb {
  transform: scale(1.15);
  background: #005bbf;
}

.congress-bill-split .chart-container {
  width: 100% !important; /* Ensure full width */
  height: auto;  /* Ensure this is consistent */
  overflow: visible;
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}

.congress-bill-split .chart-container > canvas {
  width: 100% !important; /* Ensure full width */
  height: auto;
  box-sizing: border-box;
}

@media (min-width: 768px) {
  .congress-bill-split {
    padding: 24px 48px;
    min-height: 1200px;
  }

  .congress-bill-split .chart-controls {
    flex-direction: row;
    gap: 24px;
  }

  .congress-bill-split .controls-row {
    grid-template-columns: 1fr 1fr;
    gap: 20px;
  }
}

@media (max-width: 768px) {
  .congress-bill-split {
    padding: 16px 24px;
  }

  .congress-bill-split .chart-description {
    margin-bottom: 8px;
  }

  .congress-bill-split .chart-description .text {
    font-size: 13px;
  }

  .congress-bill-split .chart-controls {
    gap: 8px;
    margin-bottom: 10px;
  }

  .congress-bill-split .controls-row {
    gap: 8px;
  }

  .congress-bill-split .baseline-select,
  .congress-bill-split .bill-status-select {
    padding: 6px 10px;
    font-size: 13px;
  }

  .congress-bill-split .baseline-selector label,
  .congress-bill-split .bill-status-selector label,
  .congress-bill-split .volume-selector label {
    font-size: 12px;
  }
}

@media (max-width: 480px) {
  .congress-bill-split .chart-container,
  .congress-bill-split .chart-container > canvas {
    height: auto;
  }
}

.congress-bill-split .charts-container {
  display: flex;
  flex-direction: column;
  gap: 48px;
  width: 100%;
  overflow-x: auto;
  padding-bottom: 16px;
}

.congress-bill-split .chart-wrapper {
  width: 100%;
  background: white;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.congress-bill-split .chart-wrapper h3 {
  margin: 0 0 24px 0;
  font-size: 18px;
  font-weight: 600;
  color: #333;
  text-align: center;
}

@media (max-width: 768px) {
  .congress-bill-split .charts-container {
    gap: 32px;
  }

  .congress-bill-split .chart-wrapper {
    padding: 16px;
  }

  .congress-bill-split .chart-wrapper h3 {
    font-size: 16px;
    margin-bottom: 16px;
  }
}

/* Increase specificity by adding parent class */
.analytics-page-wrapper .congress-bill-split {
  width: 100%;
  max-width: 1220px;
  min-height: 600px;
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  padding: 24px 18px;
  box-sizing: border-box;
  margin: 0 auto;
}

.analytics-page-wrapper .congress-bill-split .chart-container {
  position: relative;
  width: 100% !important; /* Ensure full width */
  height: auto;
  overflow: visible;
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}

.analytics-page-wrapper .congress-bill-split .chart-container > canvas {
  width: 100% !important; /* Ensure full width */
  height: auto;
  box-sizing: border-box;
}

/* Add more specific selectors for other elements as needed */
`, "",{"version":3,"sources":["webpack://./src/components/CongressBillSplit/style.css"],"names":[],"mappings":"AAAA,0CAA0C;AAC1C;EACE,WAAW;EACX,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,wCAAwC;EACxC,kBAAkB;EAClB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;EACX,SAAS;AACX;;AAEA;;;EAGE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;;;EAGE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,yDAAif;EACjf,4BAA4B;EAC5B,sCAAsC;EACtC,oBAAoB;AACtB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;;EAEE,qBAAqB;EACrB,aAAa;EACb,4CAA4C;AAC9C;;AAEA;;EAEE,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;;EAEE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,wCAAwC;EACxC,iCAAyB;EAAzB,yBAAyB;AAC3B;;AAEA;;EAEE,qBAAqB;EACrB,yCAAyC;AAC3C;;AAEA;;EAEE,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB,EAAE,sBAAsB;EAC9C,YAAY,GAAG,8BAA8B;EAC7C,iBAAiB;EACjB,UAAU;EACV,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,sBAAsB,EAAE,sBAAsB;EAC9C,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE;IACE,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,8BAA8B;IAC9B,SAAS;EACX;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,QAAQ;IACR,mBAAmB;EACrB;;EAEA;IACE,QAAQ;EACV;;EAEA;;IAEE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;;;IAGE,eAAe;EACjB;AACF;;AAEA;EACE;;IAEE,YAAY;EACd;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE;IACE,SAAS;EACX;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;AACF;;AAEA,gDAAgD;AAChD;EACE,WAAW;EACX,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,wCAAwC;EACxC,kBAAkB;EAClB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB,EAAE,sBAAsB;EAC9C,YAAY;EACZ,iBAAiB;EACjB,UAAU;EACV,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,sBAAsB,EAAE,sBAAsB;EAC9C,YAAY;EACZ,sBAAsB;AACxB;;AAEA,6DAA6D","sourcesContent":["/* Add unique namespace to all selectors */\n.congress-bill-split {\n  width: 100%;\n  max-width: 1220px;\n  min-height: 600px;\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  padding: 24px 18px;\n  box-sizing: border-box;\n  margin: 0 auto;\n}\n\n.congress-bill-split .chart-description {\n  margin-bottom: 16px;\n  width: 100%;\n}\n\n.congress-bill-split .chart-description .text {\n  color: #666;\n  line-height: 1.6;\n  font-size: 16px;\n  width: 100%;\n}\n\n.congress-bill-split .chart-controls {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  margin-bottom: 20px;\n  align-items: center;\n  width: 100%;\n  max-width: 800px;\n  margin: 0 auto;\n  padding: 16px;\n  background: #f9f9f9;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.congress-bill-split .controls-row {\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n  gap: 20px;\n}\n\n.congress-bill-split .baseline-selector,\n.congress-bill-split .bill-status-selector,\n.congress-bill-split .volume-selector {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.congress-bill-split .baseline-selector label,\n.congress-bill-split .bill-status-selector label,\n.congress-bill-split .volume-selector label {\n  text-align: center;\n  display: block;\n  margin-bottom: 8px;\n  color: #333;\n  font-size: 15px;\n  font-weight: 600;\n}\n\n.congress-bill-split .baseline-select,\n.congress-bill-split .bill-status-select {\n  width: 100%;\n  padding: 8px 12px;\n  border-radius: 6px;\n  border: 1px solid #e0e0e0;\n  font-size: 14px;\n  background: white;\n  color: #333;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  appearance: none;\n  background-image: url(\"data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%22292.4%22%20height%3D%22292.4%22%3E%3Cpath%20fill%3D%22%23333%22%20d%3D%22M287%2069.4a17.6%2017.6%200%200%200-13-5.4H18.4c-5%200-9.3%201.8-12.9%205.4A17.6%2017.6%200%200%200%200%2082.2c0%205%201.8%209.3%205.4%2012.9l128%20127.9c3.6%203.6%207.8%205.4%2012.8%205.4s9.2-1.8%2012.8-5.4L287%2095c3.5-3.5%205.4-7.8%205.4-12.8%200-5-1.9-9.2-5.4-12.8z%22%2F%3E%3C%2Fsvg%3E\");\n  background-repeat: no-repeat;\n  background-position: right 12px center;\n  background-size: 8px;\n}\n\n.congress-bill-split .baseline-select:hover,\n.congress-bill-split .bill-status-select:hover {\n  border-color: #0072ed;\n}\n\n.congress-bill-split .baseline-select:focus,\n.congress-bill-split .bill-status-select:focus {\n  border-color: #0072ed;\n  outline: none;\n  box-shadow: 0 0 0 3px rgba(0, 114, 237, 0.1);\n}\n\n.congress-bill-split .volume-slider,\n.congress-bill-split .baseline-slider {\n  width: 100%;\n  height: 6px;\n  background: #edf2f7;\n  border-radius: 8px;\n  cursor: pointer;\n  appearance: none;\n  margin: 10px 0;\n  transition: all 0.2s ease;\n}\n\n.congress-bill-split .volume-slider::-webkit-slider-thumb,\n.congress-bill-split .baseline-slider::-webkit-slider-thumb {\n  appearance: none;\n  width: 20px;\n  height: 20px;\n  background: #0072ed;\n  border: 3px solid #ffffff;\n  border-radius: 50%;\n  cursor: pointer;\n  margin-top: -7px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  transition: all 0.2s ease;\n}\n\n.congress-bill-split .volume-slider:hover::-webkit-slider-thumb,\n.congress-bill-split .baseline-slider:hover::-webkit-slider-thumb {\n  transform: scale(1.1);\n  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.15);\n}\n\n.congress-bill-split .volume-slider:active::-webkit-slider-thumb,\n.congress-bill-split .baseline-slider:active::-webkit-slider-thumb {\n  transform: scale(1.15);\n  background: #005bbf;\n}\n\n.congress-bill-split .chart-container {\n  width: 100% !important; /* Ensure full width */\n  height: auto;  /* Ensure this is consistent */\n  overflow: visible;\n  padding: 0;\n  margin: 0;\n  box-sizing: border-box;\n}\n\n.congress-bill-split .chart-container > canvas {\n  width: 100% !important; /* Ensure full width */\n  height: auto;\n  box-sizing: border-box;\n}\n\n@media (min-width: 768px) {\n  .congress-bill-split {\n    padding: 24px 48px;\n    min-height: 1200px;\n  }\n\n  .congress-bill-split .chart-controls {\n    flex-direction: row;\n    gap: 24px;\n  }\n\n  .congress-bill-split .controls-row {\n    grid-template-columns: 1fr 1fr;\n    gap: 20px;\n  }\n}\n\n@media (max-width: 768px) {\n  .congress-bill-split {\n    padding: 16px 24px;\n  }\n\n  .congress-bill-split .chart-description {\n    margin-bottom: 8px;\n  }\n\n  .congress-bill-split .chart-description .text {\n    font-size: 13px;\n  }\n\n  .congress-bill-split .chart-controls {\n    gap: 8px;\n    margin-bottom: 10px;\n  }\n\n  .congress-bill-split .controls-row {\n    gap: 8px;\n  }\n\n  .congress-bill-split .baseline-select,\n  .congress-bill-split .bill-status-select {\n    padding: 6px 10px;\n    font-size: 13px;\n  }\n\n  .congress-bill-split .baseline-selector label,\n  .congress-bill-split .bill-status-selector label,\n  .congress-bill-split .volume-selector label {\n    font-size: 12px;\n  }\n}\n\n@media (max-width: 480px) {\n  .congress-bill-split .chart-container,\n  .congress-bill-split .chart-container > canvas {\n    height: auto;\n  }\n}\n\n.congress-bill-split .charts-container {\n  display: flex;\n  flex-direction: column;\n  gap: 48px;\n  width: 100%;\n  overflow-x: auto;\n  padding-bottom: 16px;\n}\n\n.congress-bill-split .chart-wrapper {\n  width: 100%;\n  background: white;\n  border-radius: 12px;\n  padding: 24px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n}\n\n.congress-bill-split .chart-wrapper h3 {\n  margin: 0 0 24px 0;\n  font-size: 18px;\n  font-weight: 600;\n  color: #333;\n  text-align: center;\n}\n\n@media (max-width: 768px) {\n  .congress-bill-split .charts-container {\n    gap: 32px;\n  }\n\n  .congress-bill-split .chart-wrapper {\n    padding: 16px;\n  }\n\n  .congress-bill-split .chart-wrapper h3 {\n    font-size: 16px;\n    margin-bottom: 16px;\n  }\n}\n\n/* Increase specificity by adding parent class */\n.analytics-page-wrapper .congress-bill-split {\n  width: 100%;\n  max-width: 1220px;\n  min-height: 600px;\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  padding: 24px 18px;\n  box-sizing: border-box;\n  margin: 0 auto;\n}\n\n.analytics-page-wrapper .congress-bill-split .chart-container {\n  position: relative;\n  width: 100% !important; /* Ensure full width */\n  height: auto;\n  overflow: visible;\n  padding: 0;\n  margin: 0;\n  box-sizing: border-box;\n}\n\n.analytics-page-wrapper .congress-bill-split .chart-container > canvas {\n  width: 100% !important; /* Ensure full width */\n  height: auto;\n  box-sizing: border-box;\n}\n\n/* Add more specific selectors for other elements as needed */\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
